import { loadStripe, Stripe } from '@stripe/stripe-js';

let stripePromise: Promise<Stripe | null>;

export const getStripe = () => {
  if (!stripePromise) {
    const publishableKey = process.env.NEXT_PUBLIC_STRIPE_PUBLISHABLE_KEY;
    
    console.log('\n=== STRIPE CLIENT INITIALIZATION (FRONTEND) ===');
    console.log('Publishable key exists:', !!publishableKey);
    console.log('Publishable key prefix:', publishableKey?.substring(0, 8) + '...');
    
    if (!publishableKey) {
      console.error('❌ NEXT_PUBLIC_STRIPE_PUBLISHABLE_KEY is not set');
      throw new Error('Stripe publishable key is missing');
    }
    
    if (!publishableKey.startsWith('pk_test_') && !publishableKey.startsWith('pk_live_')) {
      console.error('❌ Invalid Stripe publishable key format');
      throw new Error('Stripe publishable key has invalid format');
    }
    
    const mode = publishableKey.startsWith('pk_test_') ? 'test' : 'live';
    console.log('✅ Publishable key mode:', mode);
    console.log('✅ Expected secret key mode:', mode === 'test' ? 'sk_test_' : 'sk_live_');
    console.log('\n⚠️ CRITICAL: This publishable key MUST match the secret key account on backend');
    console.log('⚠️ If you see "No such payment_intent" error, the keys are from DIFFERENT Stripe accounts');
    console.log('⚠️ Solution: Go to Stripe Dashboard → API Keys → Copy BOTH keys from SAME screen\n');
    
    stripePromise = loadStripe(publishableKey);
  }
  return stripePromise;
};